export function roundTo(val: number, decimals: number = 1): string {
  return val.toFixed(decimals);
}

export function asNumber(value: unknown | undefined): number {
  return Number.isFinite(value) ? Number(value) : 0;
}

export function tryOrMessage<T>(fn: () => T, msg: string = "?"): string {
  try {
    return "" + fn();
  } catch (e: unknown) {
    return msg;
  }
}

function _canonize(text: string): string[] {
  return (
    text
      .split(/([ _-]|(?=[A-Z]))/g)
      .filter((v) => v && ![" ", "_", "-"].includes(v))
      .reduce((acc: string[], val: string) => {
        // We agglomerate successive ABC
        const previous = acc.at(-1);
        if (previous && val.match(/^[A-Z]+$/g) && previous.match(/^[A-Z]+$/g)) {
          acc[acc.length - 1] = previous + val;
        } else {
          acc.push(val);
        }
        return acc;
      }, [])
      // Reduce only if not fully uppercase (ex: CDC)
      .map((v) => (v.match(/^[A-Z]+$/) ? v : v.toLowerCase()))
  );
}

function toUpperWordCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.substring(1);
}

// /**
//  * (lower) camelCase (abcDefGhi - to use in object)
//  *
//  * @see https://en.wikipedia.org/wiki/Letter_case#Special_case_styles
//  */
// export function toPropertyCase(
//   text: string,
//   firstUpper: boolean = false
// ): string {
//   return _canonize(text)
//     .map((s, i) => (i > 0 || firstUpper ? toUpperWordCase(s) : s))
//     .join("");
// }

/**
 * Transform into kebab case (abc-def-ghi - to use in html)
 *
 * @see https://en.wikipedia.org/wiki/Letter_case#Special_case_styles
 */
export function toAttributeCase(text: string): string {
  return _canonize(text).join("-");
}

/**
 * @param {string} text to be transformed (abc dev ghi)
 * @returns {string} the test in title case (Abc Def Ghi)
 */
export function toTitleCase(text: string): string {
  return _canonize(text).map(toUpperWordCase).join(" ");
}

// TODO: Use new function
export function escapeRegExp(string: string): string {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions#escaping
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

// From 1960 to 2039 (see help text on patient-element)
export const yearOfBirthPattern =
  "(19[6-9][0-9]|20[0-3][0-9])(-(0?[1-9]|1[0-2]))?";
